import { render, staticRenderFns } from "./Toaster.vue?vue&type=template&id=21480438"
import script from "./Toaster.vue?vue&type=script&lang=js"
export * from "./Toaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports